import { InjectionToken } from '@angular/core';
import { LogLevel } from './log-level';

/**
 * Severity floors, one per destination.
 *
 * They are independent by design. Raising console detail locally must not change what is ingested,
 * and lowering the telemetry floor to diagnose a remote installation must not depend on anyone
 * being able to see that machine's console.
 *
 * No severity is excluded structurally — what a destination receives is a function of its floor
 * alone. `trackEvent`/`trackMetric` are not logging: their telemetry delivery is subject to no
 * floor at all, though their console line follows the console floor.
 */
export interface LoggingConfig {
    /** Floor for console output. Defaults to {@link LogLevel.VERBOSE}. */
    consoleLevel?: LogLevel;

    /**
     * Floor for telemetry. Defaults to {@link LogLevel.INFO}.
     *
     * `INFO` is a measured default: client telemetry runs at roughly 0.7 GB/day against a 100 GB
     * daily cap, so the business events at this level cost a fraction of a percent of an unused
     * budget and are what make a support investigation tractable.
     */
    telemetryLevel?: LogLevel;
}

export const LOGGING_CONFIG = new InjectionToken<LoggingConfig>('LOGGING_CONFIG');

export const DEFAULT_CONSOLE_LEVEL = LogLevel.VERBOSE;
export const DEFAULT_TELEMETRY_LEVEL = LogLevel.INFO;
